module.exports = __webpack_public_path__ + "static/media/MonumentalFragments.579bfc24.png";